module.exports = require("is-async-supported");


//////////////////
// WEBPACK FOOTER
// external "is-async-supported"
// module id = 23
// module chunks = 0